var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistoryUnstakeCancel = function SvgHistoryUnstakeCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M4.537 10V8.68h6.04a.143.143 0 0 0 .143-.143V7.466a.143.143 0 0 0-.143-.143h-6.04V6a.142.142 0 0 0-.23-.113l-2.532 2a.143.143 0 0 0 0 .225l2.53 2a.144.144 0 0 0 .232-.113m5.505-8.536v1.072c0 .078.064.142.143.142h2.75V13.32h-2.75a.143.143 0 0 0-.143.143v1.072c0 .078.064.142.143.142h3.535a.57.57 0 0 0 .571-.57V1.892a.57.57 0 0 0-.57-.572h-3.536a.143.143 0 0 0-.143.143"
  })));
};
export default SvgHistoryUnstakeCancel;